module.exports = __webpack_public_path__ + "static/group1_2-a3825ee7489cdb097a31a0e01bbf748e.webp";